import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroceriesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.44007 14.8344C1.44007 14.8344 -0.882424 12.1532 1.77344 8.8925C4.42931 5.63176 9.40037 7.30732 10.3042 10.137C10.7283 11.458 10.6032 12.7859 10.3598 13.8149",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.01501 9.78258C5.01501 9.78258 5.45997 6.24375 1.44141 5.27734",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.04688 9.53906C4.04688 9.53906 4.98547 10.1231 5.97968 9.53906H4.04688Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.04688 9.53906C4.04688 9.53906 4.98547 10.1231 5.97968 9.53906",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.86328 8.23798V6.61109C8.86328 5.58907 9.69063 4.76172 10.7127 4.76172H13.299C14.321 4.76172 15.1484 5.58907 15.1484 6.61109V13.4385",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6095 0.5H9.82031V2.88889H14.6095V0.5Z",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9414 5.77008C14.9414 5.77008 17.0689 2.05743 20.4617 2.55106C23.8545 3.04469 23.1315 9.72607 19.4745 13.2858",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2031 5.2771C18.2031 5.2771 19.4004 4.67964 20.5977 5.27763",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.0039 7.66677C17.0039 7.66677 18.1756 7.02721 19.9972 7.66699",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.0039 10.0556C17.0039 10.0556 18.2012 9.46049 19.3985 10.0558",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.3125 14.4546C1.3125 14.4546 2.48297 14.7699 3.83337 13.6399C5.03067 12.638 5.5744 11.9239 7.52111 14.0166C9.46782 16.1093 11.0808 12.1881 13.2639 12.2229C15.447 12.2576 15.44 16.5056 19.4725 13.2866L17.9777 21.6436C17.7274 23.0341 16.5177 24.0491 15.1063 24.0491H5.52573C4.12132 24.0491 2.91158 23.048 2.65434 21.6644L1.3125 14.4546Z",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0195 2.88867V4.68034",
			stroke: "#00666D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.03125 16.0273L6.22855 21.9996",
			stroke: "#00666D",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0195 20.8047H14.6114",
			stroke: "#00666D",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4141 2.88867V4.68034",
			stroke: "#00666D"
		})
	]
});
export default SvgGroceriesIcon;
